<template>
  <scroll-tracker
    v-if="trackScrollEnabled"
    event-source="window"
    :get-scroll-position="getScrollPosition"
    :get-scrollable-height="getScrollableHeight"
    :build-event="buildScrollEvent"
  />
  <klaviyo />
</template>

<script>
/**
 * Vue: Analytics Index (analytics)
 * -----------------------------------------------------------------------------
 * Entry point for analytics
 *
 */

import { track } from '~/helpers/datalayer-actions';
import Klaviyo from '~global/analytics/klaviyo';
import ScrollTracker from '~global/analytics/scroll-tracker';

export default {
  name: 'AnalyticsIndex',

  components: {
    Klaviyo,
    ScrollTracker,
  },

  computed: {
    trackScrollEnabled() {
      return this.$variable('analytics.trackScroll')
        || this.$variable('request.pageType') === 'index'
    },
  },

  created() {
    this.trackSession()
  },

  methods: {
    getScrollPosition() {
      return window.scrollY
    },

    getScrollableHeight() {
      return document.documentElement.scrollHeight
        - window.innerHeight
    },

    buildScrollEvent(percent) {
      const eventObj = {
        event: `scroll_${percent}`,
        jh_value: percent,
        percent_scrolled: percent,
      }

      if (this.$variable('request.pageType') === 'product') {
        return {
          ...eventObj,
          event: 'pdp_scroll_depth',
          item_sku: this.$variable('product.sku'),
          item_name: this.$variable('product.title'),
          item_id: this.$variable('product.styleNo'),
        }
      }

      return eventObj
    },

    /**
     * Track `custom_session` if session storage item doesn't exist
     */
    trackSession() {
      const SESSION_KEY = 'cnvs-session-start'
      const sessionStart = sessionStorage.getItem(SESSION_KEY)
      if (sessionStart) {
        return
      }
      sessionStorage.setItem(SESSION_KEY, Date.now())
      const event = {
        event: 'custom_session',
        jh_source: location.pathname,
        link_url: '',
      }

      if (this.$variable('request.pageType') === 'page') {
        event.link_url = location.href
      }

      track(event)
    },
  },
}
</script>
